import VueRouter from "vue-router";
import Experiences from "@/components/Experiences";
import Companies from "@/components/Companies";
import Company from "@/components/Company";
import Favorites from "@/components/Favorites";
import Exact from "@/components/Exact";
import PDF from "@/components/PDF";

export const router = new VueRouter({
  routes: [
    {
      path: "/reviews/page",
      component: Experiences,
      beforeEnter(to, from, next) {
        next("/reviews/page/1");
      },
    },
    {
      path: "/reviews/page/:pagenumber",
      component: Experiences,
      beforeEnter(to, from, next) {
        localStorage.setItem("postsPage", to.params.pagenumber + "");
        next();
      },
    },
    {
      path: "/companies/page",
      component: Companies,
      beforeEnter(to, from, next) {
        next("/companies/page/1");
      },
    },
    {
      path: "/companies/page/:pagenumber",
      component: Companies,
      beforeEnter(to, from, next) {
        localStorage.setItem("organisationsPage", to.params.pagenumber + "");
        next();
      },
    },
    { path: "/", component: Companies },
    { path: "/company/:id", component: Company },
    {
      path: "/favorites/page",
      component: Favorites,
      beforeEnter(to, from, next) {
        next("/favorites/page/1");
      },
    },
    {
      path: "/favorites/page/:pagenumber",
      component: Favorites,
      beforeEnter(to, from, next) {
        localStorage.setItem("favoritesPage", to.params.pagenumber + "");
        next();
      },
    },
    {
      path: "/exact/page/:pagenumber",
      component: Exact,
      beforeEnter(to, from, next) {
        localStorage.setItem("exactPage", to.params.pagenumber + "");
        next();
      },
    },
    {
      path: "/exact/page",
      component: Exact,
      beforeEnter(to, from, next) {
        next("/exact/page/1");
      },
    },
    {
      path: "/pdf",
      component: PDF,
      props: true,
    },
    {
      path: "/logout",
      beforeEnter(to, from, next) {
        next("/");
      }
    }
  ],
  mode: "history",
});
